module.exports = __webpack_public_path__ + "static/img/no.3513b95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no.png
// module id = 5iK7
// module chunks = 1